import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { UserInfo } from './Model/UserInfo';
import { environment } from '../../../../environments/environment';

@Injectable()
export class UserinfoService {

  userinfo:UserInfo;
  baseUrl: string;
  path: string;


  constructor(
    public http:HttpClient
  ) {
   this.baseUrl =  `${environment.apiHost}`;
   this.path = '/makpak/userinfo';

  }

  async loadUserInfo():Promise<UserInfo> {
    const response = await this.http.get(this.baseUrl + this.path).toPromise();
    this.userinfo = JSON.parse(JSON.stringify(response));
    return this.userinfo;
  }

  getUserinfo():UserInfo{
    return this.userinfo;
  }

  setUserinfo(user: UserInfo){
    this.userinfo=user;
  }
}


